import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import mediaQueries from 'syf-component-library/const/mediaQueries';
import { colors, fontSizes, fontWeights, spacing } from 'syf-component-library/defaultTheme';
import { Button, CardRow } from 'syf-component-library/ui/atoms';
import { Inset, Stack } from 'syf-component-library/ui/spacing';
import Body from 'syf-component-library/ui/typography/Body';
import { t } from '../../../strings/i18n';
import { AdditionalInfoWrapper } from '../../atoms/styled';
const CardBody = styled(Body) `
  ${(props) => props.flex && `flex: ${props.flex};`}
  padding-bottom: ${spacing.base}px;
`;
const ContentWrapper = styled.div `
  flex: 2;
  margin-right: ${spacing.small}px;

  @media ${mediaQueries.greaterThanMedium} {
    padding-top: 0px;
    display: flex;
  }
`;
export const DetailsTitle = styled(Body) `
  font-size: ${fontSizes.medium}px;
  font-weight: ${fontWeights.light};
  padding: 0 0 ${spacing.medium}px 0;
`;
export const EditPaymentButton = styled(Button) `
  margin: ${spacing.small}px ${spacing.base}px ${spacing.small}px 0px;
  padding-left: 0px;
  :disabled {
    color: ${colors.darkGrey};
    text-decoration: none;
  }
`;
export const PaymentDetailsWrapper = styled(Inset) `
  padding-left: 0px;
  padding-right: 0px;
`;
export const PaymentDetailsInnerWrapper = styled.div `
  padding: ${spacing.base}px ${spacing.large}px ${spacing.large}px
    ${spacing.large}px;
  @media ${mediaQueries.lessThanMedium} {
    padding-left: 0px;
    padding-right: 0px;
  }
`;
export const PaymentDetailsContentRow = ({ children, dataCyForLabel, dataCyForSubText, dataCyForValue, label, subtext, value }) => {
    return (_jsx(CardRow, { children: _jsxs(ContentWrapper, { children: [_jsx(CardBody, Object.assign({ "data-cy": dataCyForLabel, flex: "5", isInline: true }, { children: t(label) })), _jsx(Stack, { size: "xsmall" }), _jsxs(CardBody, Object.assign({ "data-cy": dataCyForValue, flex: "9", weight: "bold" }, { children: [t(value), subtext && (_jsx(AdditionalInfoWrapper, Object.assign({ "data-cy": dataCyForSubText }, { children: subtext }))), children] }))] }) }));
};
